/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Common_Import_File_CountInputs */

const en_common_import_file_count = /** @type {(inputs: Common_Import_File_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en", i?.count, {});
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Import files`);
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Import ${i?.count} file`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Import ${i?.count} files`);
	return /** @type {LocalizedString} */ ("common_import_file_count");
};

const es_common_import_file_count = /** @type {(inputs: Common_Import_File_CountInputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es", i?.count, {});
	if ((i?.count === 0 || i?.count === "0")) return /** @type {LocalizedString} */ (`Importar archivos`);
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Importar ${i?.count} archivo`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Importar ${i?.count} archivos`);
	return /** @type {LocalizedString} */ ("common_import_file_count");
};

/**
* | count | countPlural | output |
* | --- | --- | --- |
* | "0" | * | "Import files" |
* | * | "one" | "Import {count} file" |
* | * | "other" | "Import {count} files" |
*
* @param {Common_Import_File_CountInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_import_file_count = /** @type {((inputs: Common_Import_File_CountInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Import_File_CountInputs, { locale?: "en" | "es" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_import_file_count(inputs)
	return en_common_import_file_count(inputs)
});